// SPDX-License-Identifier: AGPL-3.0-or-later

import type { QuestionnaireResponse } from '@intakeform/fhir';
import type { DraftAnswers } from '@intakeform/ui';

/**
 * Project a FHIR QuestionnaireResponse back to the in-memory
 * DraftAnswers shape the Renderer wants. Mirror of the toAnswer
 * serialization in stores/intake.ts — keep them in sync if the answer
 * payload schema changes.
 */
export function qrToDraftAnswers(qr: QuestionnaireResponse): DraftAnswers {
  const out: DraftAnswers = {};
  for (const item of qr.item ?? []) {
    const answer = item.answer?.[0];
    if (answer === undefined) continue;
    out[item.linkId] = unwrapAnswerValue(answer);
  }
  return out;
}

function unwrapAnswerValue(a: Record<string, unknown>): unknown {
  if ('valueString' in a) return a['valueString'];
  if ('valueInteger' in a) return a['valueInteger'];
  if ('valueDecimal' in a) return a['valueDecimal'];
  if ('valueBoolean' in a) return a['valueBoolean'];
  if ('valueDate' in a) return a['valueDate'];
  if ('valueDateTime' in a) return a['valueDateTime'];
  if ('valueTime' in a) return a['valueTime'];
  if ('valueCoding' in a) return a['valueCoding'];
  if ('valueReference' in a) return a['valueReference'];
  if ('valueAttachment' in a) return a['valueAttachment'];
  return a;
}

export function statusLabel(s: string): string {
  switch (s) {
    case 'pending_admin_review':
      return 'Pending admin review';
    case 'pending_doctor_approval':
      return 'Pending doctor approval';
    case 'approved':
      return 'Approved (not yet published)';
    case 'rejected':
      return 'Rejected';
    case 'published':
      return 'Published to EMR';
    default:
      return s;
  }
}
